import React from 'react'

import { useBreakpoint } from '@sketch/components'
import {
  EyeIcon,
  StyledText,
  Wrapper,
  Bold,
  StyledLink,
} from './HiddenProfileBanner.styles'
import { routes } from '@sketch/modules-common'

interface HiddenProfileBannerProps {
  shortUrlName: string
}

export const HiddenProfileBanner: React.FCC<HiddenProfileBannerProps> = ({
  shortUrlName,
}) => {
  const isMobile = !useBreakpoint('xs')

  return (
    <Wrapper>
      {isMobile ? (
        <>
          <EyeIcon width="17" height="17" />
          <StyledText>Hidden — Only Admins see profile.</StyledText>
        </>
      ) : (
        <>
          <EyeIcon width="17" height="17" />
          <StyledText>
            <Bold>Hidden</Bold> — Only you and other Admins in this Workspace
            can{' '}
            <StyledLink
              variant="secondary"
              isUnderlined
              target="_blank"
              to={routes.WORKSPACE_PROFILE.create({
                shortUrlName,
              })}
            >
              see your profile.
            </StyledLink>
          </StyledText>
        </>
      )}
    </Wrapper>
  )
}
